import { jsx as _jsx } from "react/jsx-runtime";
import { useFetch } from '@rad/hooks';
import Skeleton from '@rad/components/utility/skeleton';
import { getPublicTour, getTour } from '../../../common/network/tour';
import { useTourPreview } from '../../../hooks/useTourPreview';
import TourClosed from './components/tour-closed';
import TourMapContent from './components/tour-map-content';
// Every home on a tour on one map, with the same homes listed beneath it. Homes are a set, not a
// route: no order, no distances, and filters in place of modes.
const TourMapPage = (props) => {
    const previewing = useTourPreview();
    const [tourPromise] = useFetch(previewing ? getTour(false, props.id) : getPublicTour(props.id));
    return (_jsx(Skeleton, { promise: tourPromise, shell: _jsx("div", { className: "container pt-3", children: _jsx("div", { className: "tour-map-stage skeleton-block", "aria-busy": "true" }) }), children: tour => tour === null
            ? _jsx(TourClosed, { tourId: props.id })
            : _jsx(TourMapContent, { tour: tour, previewing: previewing }) }));
};
export default TourMapPage;
